import React, { createContext, useContext, useState, useMemo, ReactNode } from 'react';
import { Is } from '../types';

interface AppContextType {
  addJobDialogOpen: boolean;
  setAddJobDialogOpen: (open: boolean) => void;
  selectedJobForPrint: Is | null;
  setSelectedJobForPrint: (job: Is | null) => void;
}

const AppContext = createContext<AppContextType | undefined>(undefined);

export const useAppContext = () => {
  const context = useContext(AppContext);
  if (context === undefined) {
    throw new Error('useAppContext must be used within an AppProvider');
  }
  return context;
};

interface AppProviderProps {
  children: ReactNode;
}

export const AppProvider: React.FC<AppProviderProps> = ({ children }) => {
  const [addJobDialogOpen, setAddJobDialogOpen] = useState(false);
  const [selectedJobForPrint, setSelectedJobForPrint] = useState<Is | null>(null);

  const value = useMemo(() => ({
    addJobDialogOpen,
    setAddJobDialogOpen,
    selectedJobForPrint,
    setSelectedJobForPrint,
  }), [addJobDialogOpen, selectedJobForPrint]);

  return (
    <AppContext.Provider value={value}>
      {children}
    </AppContext.Provider>
  );
}; 